import { Route, Routes } from 'react-router-dom'
import ContactsPage from './Page'

export default function Contacts() {
  return (
    <Routes>
      <Route path="/*" element={<ContactsPage />} />
      <Route path="/:contactId" element={<ContactsPage />} />
    </Routes>
  )
}
